<img
	[ngClass]="'ikea-logo' | prefix: prefix"
	src="/assets/logo/ikea-logo.svg"
	alt="IKEA Logotype"
/>
